export const blue = "#153990";
export const white = "#ffffff";
export const red = "#c1272d";
export const black = "#000000";
export const lightGray = "#f5f5f5";
export const darkRed = "#fc5b5b";
export const lightRed = "#fa8484";
export const lightYellow = "#faf69d";
export const darkYellow = "#faf366";
export const lightOrange = "#f5a53d";
export const darkOrange = "#f78e05";
export const darkGreen = "#0cfa44";
export const lightGreen = "#68f78a";
export const darkBlue = "#058af7";
export const lightBlue = "#6bbafa";
export const darkPurple = "#fa6bf3";
export const lightPurple = "#fa96f5";
export const lightBrown = "#cfcfcf";

export const colorPairs = [
  lightBlue,
  darkBlue,
  lightRed,
  darkRed,
  lightGreen,
  darkGreen,
  lightOrange,
  darkOrange,
  lightYellow,
  darkYellow,
  lightPurple,
  darkPurple,
];
